// ENG-2551: which folded-state category picker parents see on phones.
//
// Both variants are production-ready and covered by tests; exactly one is live
// at a time, for every studio and both background surfaces (the YPX/BYO wizard
// and the regular-product picker). Swapping is a one-line change here — no
// per-studio flag, no database column, no deploy-time config.
//
//   'chips'    — horizontally scrollable chip row. Switching to an adjacent
//                category is a single tap and neighbouring category names stay
//                visible, which suits browsing a merchandising surface. Costs
//                a horizontal scroll to reach categories beyond the first few.
//   'dropdown' — a native <select>. Opens the OS picker at the bottom of the
//                screen (the easy-reach zone one-handed), shows every category
//                at once, and carries native keyboard/screen-reader support.
//                Costs a second tap to switch.
//
// See docs/superpowers/specs/2026-08-12-eng-2551-mobile-backgrounds-fold-design.md
// for the ergonomics trade-off behind keeping both.
export type CategoryPickerVariant = 'chips' | 'dropdown';

export const CATEGORY_PICKER_VARIANT: CategoryPickerVariant = 'dropdown';
